import React from "react";

import { Link } from "react-router-dom"; 

const FactoryAutomationCard = () => {
  return (
    
      <div className="card w-25 h-auto">
        <div className="card-body">
          <h5 className="card-title">AWS Practioner Certified</h5>
          <p className="card-text">
          This application was build in ReactJS and is been hosted on AWS usgin a S3 bucket and CloudFront.
          </p>
        </div>
      </div>
  );
};

export default FactoryAutomationCard;
